<template>
  <div class="changePassword-right">
      <h3>重置密码</h3>
      <div class="main">
        <p>
            <span>原密码登录</span>
            <input type="password" v-model="oldPassword"><br>
            <i>您必须填写原密码才能修改下面的资料！</i>
        </p>
         <p>
            <span>新密码登录</span>
            <input type="password" v-model="newPassword" @focus="info" @blur="msg=false"><br>
            <span class="msg" v-if="msg">长度8-16位，必须包含数字字母特殊符号 #@!~%^&*</span>
        </p>
        <p>
            <span>确认新密码</span>
            <input type="password" v-model="newPasswords">
        </p>
      </div>
      <button @click="submit()">确认修改密码</button>
  </div>
</template>
<script>
export default {
  data(){
      return{
        oldPassword:'',
        newPassword:'',
        newPasswords:'',
        msg:false
      }
  },
  methods: {
      info(){
        this.msg = true
      },
      submit(){
        this.$api.personalInfo.changePassword({
            old_password:this.oldPassword,
            password: this.newPassword
        }).then(res=>{
            if(res.status == 1){
                this.$message.closeAll()
                this.$message.success('修改密码成功');
                this.$router.push('/login')
            }else if(this.newPassword !== this.newPasswords){
                this.$message.closeAll()
                this.$message.error('两次密码不一致');
            }else{
                this.$message.closeAll()
                this.$message.warning(res.msg);
            }
        })
      }
  },
}
</script>

<style lang="less" scoped>
*{
  font-size: 16px;
}
h3{
    font-size: 24px;
    text-align: left;
    color: #333333;
    line-height: 31px;
}
.main{
    width: 586px;
    margin: auto;
    margin-top: 92px;
    p{
        margin-bottom: 30px;
        span{
            width: 70px;
            height: 24px;
            color: #333333;
        }
        i{
            font-style: normal;
            margin-left: 92px;
            color: #999999;
            letter-spacing: 1px;
        }
        input{
            width: 400px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #dddddd;
            border-radius: 3px;
            margin-left: 16px;
        }
        .msg{
            margin-left: 96px;
            color: #A52A2A;
        }
    }
}
button{ 
    width: 282px;
    height: 40px;
    background: #003871;
    color:#fff;
    border:0px;
    text-align: center;
    line-height: 21px;
    margin-top: 84px;
    margin-left: 321px;
}
</style>